if (!window.sizeGuideInitialized) {
  window.sizeGuideInitialized = true;

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('#sizeGuideText, .size-guide-text');
    if (trigger) {
      e.preventDefault();
      const wrapper = trigger.closest('.size-guide__wrapper');
      const content = wrapper ? wrapper.querySelector('.size-guide-content') : document.getElementById('sizeGuideContent');
      const overlay = wrapper ? wrapper.querySelector('.overlay') : document.getElementById('overlay');
      
      content?.classList.add('active');
      overlay?.classList.add('active');
      document.body.classList.add('modal-show');
      document.body.style.overflow = 'hidden';
      return;
    }

    const closeBtn = e.target.closest('#closeSizeGuide, .close-size-guide');
    const overlayBtn = e.target.closest('#overlay, .size-guide__wrapper .overlay');
    
    if (closeBtn || overlayBtn) {
      e.preventDefault();
      document.querySelectorAll('.size-guide-content.active, .size-guide__wrapper .overlay.active, #sizeGuideContent.active, #overlay.active').forEach(el => {
        el.classList.remove('active');
      });
      document.body.classList.remove('modal-show');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.size-guide-content.active, .size-guide__wrapper .overlay.active, #sizeGuideContent.active, #overlay.active').forEach(el => {
        el.classList.remove('active');
      });
      document.body.classList.remove('modal-show');
      document.body.style.overflow = '';
    }
  });
}
